import React from 'react';

import cs from 'classnames';
import {colors} from 'js-libs/sweetcommons/styles';
import styled, {keyframes} from 'styled-components';

import {CheckboxButton} from 'app/general/widgets/CheckboxButton';
import {StyledStepAttachedTitles} from 'app/procedures/styles';
import {gt} from 'app/utils/i18n';

const bounceHighlightKeyframe = keyframes`
    0% {background-color: transparent;}
    50% {background-color: ${colors.paleBlue};}
    100% {background-color: transparent;}
`;
const outlineBlinkKeyframe = keyframes`
    0% {
        outline-color: rgba(0, 180, 204, 0);
        outline-style: dashed;
    }
    50% {
        outline-color: rgba(0, 180, 204, 1);
    }
    100% {
        outline-color: rgba(0, 180, 204, 0);
        outline-style: dashed;
    }
`;
export const StyledStepsListDIV = styled.div.attrs<{className?: string}>(
  () => ({
    className: 'container',
  })
)`
  padding-top: 3rem;
  padding-bottom: 3rem;
  background: #fff;

  ol.steps {
    list-style: none;
    counter-reset: li;

    > * {
      padding: 1rem 0;

      &:target {
        outline-offset: 0.5rem;
        outline-style: none;
        outline-width: 2px;
        animation: ${bounceHighlightKeyframe} ease 3s,
          ${outlineBlinkKeyframe} ease-in-out 3s;
      }
    }
  }
`;

export const StyledStepContentSeparatorDiv = styled.div`
  padding-bottom: 1.5rem;
`;

interface StyledCheckboxButtonProps {
  noPadding?: boolean;
  disabled?: boolean;
  testid?: string;
}

export const StyledCheckboxButton = styled(
  CheckboxButton
).attrs<StyledCheckboxButtonProps>(({noPadding}) => ({
  className: cs('btn btn-link btn-lg py-0', noPadding ? 'px-0' : 'px-1'),
}))<StyledCheckboxButtonProps>`
  font-size: 2rem;
  line-height: 1;
  height: 2rem;
  color: ${({disabled}) => disabled && colors.mediumGray};
  cursor: ${({disabled}) => disabled && 'not-allowed'};
`;

const StepContentType = ({
  icon,
  title,
  ...other
}: {
  icon: string;
  title: string;
}) => (
  <StyledStepAttachedTitles {...other}>
    <i className={`fa fa-fw ${icon}`} /> {title}
  </StyledStepAttachedTitles>
);

export const StepAttachmentsTitle = (
  props: Record<string, string>
): JSX.Element => (
  <StepContentType {...props} icon="fa-paperclip" title={gt('Attachments')} />
);

type StepDecisionTitleProps = React.HTMLAttributes<HTMLHeadingElement>;

export const StepDecisionTitle: React.FC<StepDecisionTitleProps> = (props) => (
  <StyledStepAttachedTitles {...props}>
    {gt('Answers')}
  </StyledStepAttachedTitles>
);

export const StepAutomationTitle: React.FC<StepDecisionTitleProps> = ({
  title,
  ...rest
}) => <StyledStepAttachedTitles {...rest}>{title}</StyledStepAttachedTitles>;
export const StepFormFieldsTitle = (
  props: Record<string, string>
): JSX.Element => (
  <StepContentType {...props} icon="fa-pen-square" title={gt('Form Fields')} />
);
export const StepVideosTitle = (props: Record<string, string>): JSX.Element => (
  <StepContentType {...props} icon="fa-video" title={gt('Videos/Images')} />
);
